const DeTranslation = {
  subdomainHeader: "Bitte Workspace angeben",
  settingsHeader: "Ihr aktueller Workspace",
  next: "Weiter",
  logout: "Abmelden",
  subdomain: "Sub-Domain",
  invalidSubdomain: "Bitte geben Sie eine gültige Subdomain an",
  validation: {
    required: "Bitte dieses Feld ausfüllen",
    subdomain: {
      minLength: "Domain muss mindestens 6 Zeichen haben.",
      notAllowed: "Dieser Name ist bereits vergeben oder nicht erlaubt",
    },
  },
  loading: {
    title: "Die Seite wird geladen.",
    subtitle: "Die Seite wird geladen, bitte haben Sie etwas Geduld.",
  },
  401: "Dein Nutzerkonto {{email}} is nicht für Account {{domain}} aktiviert. Kontaktiere den Administrator oder wechsle zu einem anderen Account.",
  409: "Dein Account {{email}} ist noch nicht aktiviert. Prüfe deinen Posteingang um die Aktivierung abzuschliessen oder kontaktiere deinen Teams Administrator.",
  500: "Der Server hat nicht geantwortet. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie support@shiawa.com",
  status: {
    loadingIframe: "Iframe wird geladen",
    tokenRequest: "Token anfordern",
    tokenRequestSuccess: "Token empfangen",
  },
  appDisabled: "Die App wurde vom Admin nicht für diese Organisation freigegeben",
  ottFailed: "Fehler beim Login. Versuche es später erneut",
  loginFailed:
    "Wir konnten doch nicht einloggen. Kontaktiere den Administrator um einen deinen Account in Shiawa zu aktivieren",
  signup1: "Du hast noch keinen Account? ",
  signup2: "Hier",
  signup3: " kannst du einen erstellen",
};

export default DeTranslation;
